module.exports = __webpack_public_path__ + "img/whatsapp.52fe9a8b.svg";